export default __webpack_public_path__ + "static/media/img2.b6ad3c6b.svg";